import { Component, OnInit } from '@angular/core'
import { AngularFirestore,
  AngularFirestoreCollection } from 'angularfire2/firestore'
import { Observable } from 'rxjs/Observable'
import { Project } from './project'

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: [
    './work.component.scss',
    './work.background.scss',
    './work.breakpoints.scss'
  ]
})
export class WorkComponent {
  projects: Observable<Project[]>

  constructor(private readonly db: AngularFirestore) {
    this.projects = db.collection<Project>(
      'projects',
      ref => ref.where('status', '==', 'published')
    ).valueChanges()
  }
}



// WEBPACK FOOTER //
// ./src/app/work/work.component.ts